import {throttle} from '../util/helper';
export default class Footer {

    public static fixed() {
        const $footer = $('.footer');
        /* const footerHeight = $footer.outerHeight() || 0;
        const winHeight = $(window).height() || 0;
        const docOriginHeight=$('body').height() || 0;
        const docHeight=docOriginHeight + 50;

        console.log(footerHeight);
        console.log(winHeight);
        console.log(docHeight);

        if(winHeight>=docHeight+footerHeight || !$footer.hasClass('fixed') && winHeight>=docHeight){
            $footer.addClass('fixed');
        }else if($footer.hasClass('fixed') && winHeight<docHeight+footerHeight){
            $footer.removeClass('fixed');
        } */

        if($footer.length>0){
            $footer.addClass('fixed');
            $('body').addClass('fixed-footer');
        }
    }

    public init() {
        Footer.fixed();
        this.goTop();
    }


    public goTop () {
        const $btn = $('.btn-go-top');
        
        $btn.on('click',function(){
            $('html, body').animate({scrollTop:0}, 500);
        })

        function toggleBtn() {
            const winScroll: number = $(window).scrollTop() || 0;

            if(winScroll<600) {
                $btn.addClass('hide')
            }else {
                $btn.removeClass('hide');
            }
        }

        $(window).on('scroll',throttle(this,toggleBtn,200));
    }

}